module.exports = __webpack_public_path__ + "img/simon-fraser-university.378daa78.webp";